import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import * as getters from './getters'
import moment from "moment";

Vue.use(Vuex)

const state = {
  Debug: false,
  NoImage:false,
  PetOwnerId: null,
  PetOwnerId_Ext: null,
  ClientPractices: [],
  SlotPageNumber: 0,
  ClientPractice:null,
  SelectedClientPractice: null,
  AppointmentSlots: [],
  SelectedAppointmentDay: {},
  SelectedAppointmentDateTime: {},
  PageNumber: 1,
  VisitComments: '',
  RequestedServices: [],
  DueServices:[],
  States: [],
  Species: [],
  Sexes: [],
  Pets: [],
  SelectedPet: null,
  NewPetForm: {
    PetId:-1,
    Name: '',
    Species: '-- Select --',
    Breed: '-- Select --',
    Color: '',
    Sex: '-- Select --',
    DateOfBirth: null,
    FormattedDateOfBirth: null,
  },
  PetOwnerDetails: {
    FirstName: '',
    LastName: '',
    Phone: '',
    EmailAddress: '',
    Address: '',
    City: '',
    State:'-- Select --',
    Zip: ''
  },
  PageHeader: '',
  IsLoading: false,
  IsCalendarLoading: false,
  WidgetLinks: [{
      Id: 1,
      Name: "Location"
    },
    {
      Id: 2,
      Name: "Customer"
    },
    {
      Id: 3,
      Name: "Pet Information"
    },
    {
      Id: 4,
      Name: "Appointment"
    },
    {
      Id: 5,
      Name: "Date/Time"
    },
    {
      Id: 6,
      Name: "Summary"
    }
  ],
  IsSickAppointment:false
}

const store = new Vuex.Store({
  debug: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
})

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js